<script lang="ts" setup>
import imgConsultationUser1 from './consultation_user1.svg';
import imgConsultationUser2 from './consultation_user2.svg';
import imgConsultationUser3 from './consultation_user3.svg';

const images = {
  1: imgConsultationUser1,
  2: imgConsultationUser2,
  3: imgConsultationUser3,
} as const;

const props = defineProps<{ imageNumber: keyof typeof images }>();

const img = images[props.imageNumber];
</script>

<template>
  <div :class="$style.container">
    <div :class="[$style.container__title, $style.title]">
      <div :class="[$style.title__image, $style.image]">
        <img :src="img" alt="" loading="lazy" />
      </div>
      <p :class="[$style.title__text, $style.text]">
        <slot name="titleText" />
      </p>
    </div>
    <p :class="[$style.container__detail, $style.detail]">
      <slot name="detail" />
    </p>
  </div>
</template>

<style lang="scss" module>
.container {
  width: 100%;
  padding: 32px;
  border-radius: 12px;
  background-color: $color-background-base;
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @include mobile-only {
    flex-direction: row;
    gap: 8px;
  }
}

.image {
  height: 120px;
  width: 120px;
  flex-shrink: 0;

  @include mobile-only {
    height: 64px;
    width: 64px;
  }
}

.text {
  font-size: 28px;
  line-height: 50.4px;
  font-weight: bold;

  @include mobile-only {
    font-size: 20px;
    line-height: 28px;
  }
}

.detail {
  font-size: 16px;
  line-height: 28.8px;

  @include mobile-only {
    margin-top: 16px;
  }
}
</style>
